import { render, staticRenderFns } from "./AdminsDashboard.vue?vue&type=template&id=1da1b6f2&scoped=true&"
import script from "./AdminsDashboard.vue?vue&type=script&lang=js&"
export * from "./AdminsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AdminsDashboard.vue?vue&type=style&index=0&id=1da1b6f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da1b6f2",
  null
  
)

export default component.exports